import { AtsJob } from "src/types/merge_ats";

const StatusClasses = {
  OPEN: "bg-[rgba(38,153,63,0.05)] text-success"
};

const StatusTag = ({ job }: { job: AtsJob }) => {
  if (!job.status) return <p>N/A</p>;
  const className = StatusClasses[job.status] || "bg-[rgba(255,145,77,0.05)] text-[#FF914D]";
  return (
    <p className={className + " w-fit font-poppins font-semibold text-xs p-[10px] rounded-lg"}>
      {job.status}
    </p>
  );
};

export default StatusTag;
